(() => {
  const path = location.pathname;
  if (/\/cart\/?$/.test(path)) document.body.classList.add('nd-cart-page');
  // Preserve link labels and use the shop's existing VCDS page, not a missing page.
  const repairLinks = () => document.querySelectorAll('a[href]').forEach(link => {
    const url = new URL(link.href, location.origin);
    if (url.origin !== location.origin || !/\/pages\/vcds\/?$/.test(url.pathname)) return;
    url.pathname = url.pathname.replace(/\/pages\/vcds\/?$/, '/pages/codage-vcds');
    link.href = url.pathname + url.search + url.hash;
  });
  repairLinks();
  document.addEventListener('DOMContentLoaded', repairLinks, {once:true});
  new MutationObserver(repairLinks).observe(document.body, {childList:true,subtree:true});
})();